import * as React from "react";
import { page } from "../../components/layout/responsive";
import { Header, Meta } from "./containers/AccountDeleteFeedbackHeader";

export const AccountDeleteFeedbackPage = page({
  mobile: React.lazy(() => import("./components/AccountDeleteFeedbackForm")),
  header: Header,
  meta: Meta,
});
